import { render, staticRenderFns } from "./ArticleShare.vue?vue&type=template&id=729ec281&"
import script from "./ArticleShare.vue?vue&type=script&lang=js&"
export * from "./ArticleShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports